<template>
    <div>
        <p class="mb-2">{{ client.name }}</p>

        <b-input-group class="mb-2">
            <b-form-input
                id="current-date"
                v-model="formatted_current_date"
                type="text"
                placeholder="Date à définir"
                autocomplete="off"
                size="sm"
                disabled
                class="bg-white"
                style="height: 30px"
            ></b-form-input>
            <b-input-group-append>
                <b-form-datepicker
                    v-model="form.current_date"
                    button-only
                    right
                    label-no-date-selected="Date à définir"
                    label-prev-year="Année précédente"
                    label-next-year="Année prochaine"
                    label-prev-month="Mois précédent"
                    label-next-month="Mois prochain"
                    label-current-month="Mois actuel"
                    label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                    start-weekday="1"
                    aria-controls="current-date"
                    locale="fr"
                    @context="formatCurrentDate"
                >
                </b-form-datepicker>
            </b-input-group-append>
        </b-input-group>

        <div class="row mb-2">
            <div class="col-8 pr-1">
                <b-form-select
                    v-model="form.fiscal_year"
                    size="sm"
                    :options="fiscalYearOptions"
                >
                </b-form-select>
            </div>
            <div class="col-4 pl-1">
                <b-form-input
                    v-model="form.activity_duration"
                    size="sm"
                    placeholder="0.0"
                    class="text-center"
                >
                </b-form-input>
            </div>
        </div>

        <b-form-textarea
            id="textarea-small"
            v-model="form.comments"
            size="sm"
            placeholder="Commentaires"
            rows="4"
            class="mb-2"
        >
        </b-form-textarea>
        <b-alert variant="danger" :show="hasError" class="mb-2">{{
            errorMessage
        }}</b-alert>
        <b-button
            variant="success"
            size="sm"
            class="btn-block"
            :disabled="disableSubmit"
            @click="saveTime"
        >
            <i class="fas fa-save fa-fw fa-lg"></i> Enregistrer
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TimeSheetModal',

    data() {
        return {
            form: {},
            formatted_current_date: '',
            fiscalYearOptions: [],
        }
    },

    created() {
        // console.log('init TimeSheetModal', Date.now())
        this.initModal()
    },

    methods: {
        initModal() {
            this.$store.commit('timeSheetsVM/RESET_ERROR')
            this.form.current_date = this.$moment().format('Y-MM-DD')
            console.log('current_date', this.activityDate)
            this.getAffectationOptions()
        },

        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
            this.$store.commit(
                'timeSheetsVM/SET_CURRENT_DATE',
                this.form.current_date
            )
        },

        getAffectationOptions() {
            let action = ''
            let year = ''
            const currentYear = parseInt(this.year)
            const pastYear = currentYear - 1
            const nextYear = currentYear + 1

            switch (this.pageCode) {
                case 'ten':
                    action = 'Tenue'
                    year = currentYear
                    break
                case 'bil':
                    action = 'Bilan'
                    year =
                        this.client.end_of_exercise === 12
                            ? pastYear
                            : currentYear
                    break
                case 'sit':
                    action = 'Situation'
                    year = currentYear
                    break
                case 'jur':
                    action = 'Juridique'
                    year = currentYear
                    break
                default:
                    action = 'Exercice'
                    year = currentYear
                    break
            }

            this.fiscalYearOptions = [
                { value: pastYear, text: `${action} ${pastYear}` },
                { value: currentYear, text: `${action} ${currentYear}` },
                { value: nextYear, text: `${action} ${nextYear}` },
            ]

            this.form.fiscal_year = year
        },

        async saveTime() {
            this.form.activity_date = this.form.current_date
            this.form.client_id = this.client.id
            this.form.type = null
            this.form.time_sheet_option_id = 0
            this.form.from = 'activity_modal'
            this.form.page_code = this.pageCode
            try {
                await axios.post('/time-sheets', this.form)
                this.$bvModal.hide('modal-time-sheet')
            } catch (error) {
                console.log(error)
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$store.commit(
                            'timeSheetsVM/SET_ERROR',
                            error.response.data.meta.message
                        )
                    } else if (error.response.status === 422) {
                        this.$store.commit(
                            'timeSheetsVM/SET_ERROR',
                            error.response.data.message
                        )
                    }
                }
            }
        },
    },

    computed: {
        ...mapState({
            activityDate: (state) => state.timeSheetsVM.currentDate,
            year: (state) => state.browsing.year,
            hasError: (state) => state.timeSheetsVM.hasError,
            errorMessage: (state) => state.timeSheetsVM.errorMessage,
            client: (state) => state.data.modalData.client,
            timeSheetType: (state) => state.timeSheetsVM.type,
            pageCode: (state) => state.timeSheetsVM.pageCode,
        }),

        disableSubmit() {
            return !parseFloat(this.form.activity_duration) > 0
        },
    },
}
</script>

<style scoped></style>
